import ApiService from '../api.services';

const SystemLogService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/logsystem');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    filter: async function (data) {
        try {
            const response = await ApiService.post(`/api/logsystem/filter`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default SystemLogService;

export { SystemLogService };

